






















































import Vue from 'vue';
import DefaultLocationProp from '@/Shared/DefaultLocationProp';
import VatsAPI from '@/Shared/VatsAPI';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import PermitVehicle from './PermitVehicle';
import {Logger} from '@/Shared/Logger';

export default Vue.extend({
    props: {
        vehicle: {
            type: Object as () => PermitVehicle,
            validator: (): boolean => true,
            required: true
        },
        location: DefaultLocationProp,
    },
    beforeMount() {
        if (!this.vehicle.vehicleLicense) {
            this.isNew = true;
        }

        if (this.isNew) {
            this.isEditing = true;
        }
    },
    data() {
        return {
            isLoading: false,
            isEditing: false,
            isNew: false,
            workingCopy: {...this.vehicle} as PermitVehicle,
            validationErrors: {} as { [propName: string]: string[] }
        };
    },
    computed: {
        canSave(): boolean {
            return !!this.vehicle.vehicleLicense
                && !!this.vehicle.vehicleState
                && !!this.vehicle.vehicleMake
                && !!this.vehicle.vehicleColor;
        }
    },
    methods: {
        deleteVehicle() {
            this.$emit('deleted', this.vehicle);
        },
        edit() {
            this.isEditing = true;
        },
        cancel() {
            this.isEditing = false;
            this.workingCopy = {...this.vehicle};

            this.$emit('cancelled', this.vehicle);
        },
        save() {
            this.isEditing = false;

            this.$emit('saved', {...this.workingCopy});
        },
    },
    watch: {
        location(): void {
            this.isEditing = false;
            this.isLoading = false;
        },
        vehicle(): void {
            this.workingCopy = {...this.vehicle} as PermitVehicle;
        },
    },
});
